// Define manual path to service mappings
export const PATH_TO_SERVICE_MAP: Record<string, string> = {
  '/gdpr': 'GDPR Compliance',
  '/cyber-essentials': 'Cyber Essentials',
  '/cyber-security-assessment': 'Cyber Security Assessment',
  '/data-protection-services': 'GC01 General Consulting',
  '/dora': 'Other',
  '/gdpr-audit': 'GDPR Compliance',
  '/gdpr-gap-analyis': 'GDPR Compliance',
  '/gdpr-implementation': 'GDPR Compliance',
  '/gdpr-training': 'GDPR Training',
  '/incident-response': 'Incident Response & Forensics',
  '/iso-27001-2022': 'ISO 27001',
  '/iso-27001-audit': 'ISO 27001',
  '/iso-27001-gap-analysis': 'ISO 27001',
  '/iso-27001-implementation': 'ISO 27001',
  '/iso-27001-maintenance': 'ISO 27001',
  '/iso-27001': 'ISO 27001',
  '/iso-90001': 'ISO',
  '/managed-siem': 'Managed SIEM',
  '/nhs-dsp-toolkit': 'NHS DSP Toolkit',
  '/outsourced-dpo-services': 'Outsourced DPO',
  '/outsourced-dpo': 'Outsourced DPO',
  '/partners': 'Partners',
  '/pci-dss': 'PCI',
  '/penetration-testing-packages': 'Penetration Testing',
  '/penetration-testing-guide': 'Penetration Testing',
  '/penetration-testing-service': 'Penetration Testing',
  '/penetration-testing': 'Penetration Testing',
  '/penetration_testing_api_pen_testing': 'Penetration Testing',
  '/penetration_testing_cloud_pen_testing': 'Penetration Testing',
  '/penetration_testing_crest_ovs': 'Penetration Testing',
  '/penetration_testing_enterprise_pen_testing': 'Penetration Testing',
  '/penetration_testing_int_ext_network_pen_testing': 'Penetration Testing',
  '/penetration_testing_mobile_pen_testing': 'Penetration Testing',
  '/penetration_testing_network_pen_testing': 'Penetration Testing',
  '/penetration_testing_web_application_pen_testing': 'Penetration Testing',
  '/penetration_testing_wireless_pen_testing': 'Penetration Testing',
  '/red-teaming': 'Red Team',
  '/security-training': 'Cyber Security Training',
  '/soc': 'SOC',
  '/soc2': 'SOC II Compliance Consultancy',
  '/social-engineering': 'Social Engineering',
  '/uk-gdpr-representation': 'GDPR UK Representation',
  '/virtual_ciso': 'VCiso',
  '/vulnerability-scanning': 'Vulnerability Scanning',
  '/colocation': 'Colocation',
  '/dpo-for-schools': 'DPO For Schools',
  '/mdr': 'MDR',
  '/sjp-cyber-essentials': 'SJP Cyber Essentials',
  // Add more manual mappings as needed
};

// Helper function to generate service from pathname
export const generateServiceFromPathname = (pathname: string): string | null => {
  // Remove leading and trailing slashes
  const cleanPath = pathname.replace(/^\/|\/$/g, '');

  // First check if there's a manual mapping
  if (pathname in PATH_TO_SERVICE_MAP) {
    return PATH_TO_SERVICE_MAP[pathname];
  }

  // If path contains a valid service name, use it directly
  const pathService = cleanPath
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return pathService;
};


export const REQUIRED_SERVICE = [
  "Penetration Testing",
  "Cyber Essentials",
  "Cyber Essentials Plus",
  "Cyber Security Training",
  "GDPR Compliance",
  "GDPR Training",
  "Incident Response & Forensics",
  "ISO 27001",
  "Managed Detection and Response (MDR)",
  "Managed SIEM",
  "Outsourced DPO",
  "PCI",
  "Red Team",
  "SOC",
  "Social Engineering",
  "VCiso",
  "Vulnerability Scanning",
  "Other"
] as const;

// Function to check if service dropdown should be shown
export const shouldShowServiceDropdown = (pathname: string): boolean => {
  // If we can generate a service name from the path, don't show dropdown
  const serviceFromPath = generateServiceFromPathname(pathname);
  return !serviceFromPath;
};
